export default "/images/close-icon-white.png?da49cca37b206e997a4bf157e00915ba";